import React from "react";

import type { IGalleryImage } from "@/interfaces/IGalleryImage";

const renderItem = (item: IGalleryImage) => {
  if (item.isVideo) {
    return (
      <div className="ratio ratio-16x9 embed-responsive-item w-100">
        <iframe
          allowFullScreen
          allow="autoplay"
          src={item.original}
          title={item.description}
        />
      </div>
    );
  }
  return (
    <img
      alt={item.description}
      className="image-gallery-image"
      src={item.original}
    />
  );
};

export default renderItem;
